

















import { Component, Vue } from 'vue-property-decorator';
import { windowHelper } from '@tencent/ppd-base-libs';
import { bothReport } from '../report';

@Component({
  components: {

  },
})
export default class CIndex extends Vue {
  private eDownloadIOS() {
    // 上报
    bothReport('download.ios_click');
    windowHelper.redirect('https://itunes.apple.com/us/app/wechat/id414478124?mt=8', 450);
  }
  private eDownloadAndroid() {
    // 上报
    bothReport('download.android_click');
    windowHelper.redirect('https://play.google.com/store/apps/details?id=com.tencent.mm&hl=en_US&gl=US', 450);
  }
}
